/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var sampleLoadingTablesLoading = produce(function (draft) {
  draft.meta.loading = true;
  draft.meta.error = false;
}, initialState);
export default sampleLoadingTablesLoading;